var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mr-2",attrs:{"light":!this.$vuetify.theme.dark,"icon":""},on:{"click":function($event){return _vm.toggleDarkMode()}}},[_c('v-icon',[_vm._v(" mdi-lightbulb-"+_vm._s(this.$vuetify.theme.dark ? 'on' : 'off')+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }